import { render } from "./BrowserBackRedirectionModal.vue?vue&type=template&id=538f9870&scoped=true"
import script from "./BrowserBackRedirectionModal.vue?vue&type=script&lang=js"
export * from "./BrowserBackRedirectionModal.vue?vue&type=script&lang=js"

import "./BrowserBackRedirectionModal.vue?vue&type=style&index=0&id=538f9870&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538f9870"]])

export default __exports__